import { CostType } from '../../../generated/graphql'

export enum ISOCostCategory {
  /** "A0-A5 Ennen rakentamista / Ennen käyttövaihetta" : Initial */
  Initial = 'A0-A5',
  /** "B1-B3 Käyttö / Kunnossapito / Korjaus" : Upkeep, OtherRecurring, OtherAnnual */
  Recurring = 'B1-B3',
  /** "B4-B5 Osien vaihto / Laajamittaiset korjaukset" : Renewal, OtherOneTime */
  Maintenance = 'B4-B5',
  /** "B6 Energian käyttö" : Energy */
  Energy = 'B6',
}

export const isoCostCategoryToCostTypesMap = {
  [ISOCostCategory.Initial]: [CostType.Initial],
  [ISOCostCategory.Recurring]: [
    CostType.Upkeep,
    CostType.OtherRecurring,
    CostType.OtherAnnual,
  ],
  [ISOCostCategory.Maintenance]: [CostType.Renewal, CostType.OtherOneTime],
}
